import { Affix, Button, Card, Form, Space } from "antd";
import { GET_SINGLE_NEW_TNA_TASK_DATA } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewTaskForm from "../AddNewTask/NewTaskForm";

const UpdateNewTask = (props, ref) => {
  const { width, viewMode } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { newTaskId } = useParams();
  const [processId, setProcessId] = useState([]);

  useEffect(() => {
    if (newTaskId) {
      getNewTaskInfo(newTaskId);
    }
  }, [newTaskId]);

  const getNewTaskInfo = async (id) => {
    const query = `${GET_SINGLE_NEW_TNA_TASK_DATA}/${id}/show`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const newTaskData = response?.data?.data;
      form.setFieldsValue({
        title: newTaskData?.title,
        relation_with: "Style",
        status: newTaskData?.status,
      });
      setProcessId([newTaskData?.process?.id]);
    } else {
      HandleNotification("error", "Error!", response?.message || "Failed to get Task data");
    }
  };

  const discardForm = () => {
    navigate("/tanda/new-task");
  };

  const updateTask = () => {
    form.submit();
  };

  const actionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()}>
          Discard
        </Button>

        <Button size="small" key={2} type="primary" onClick={() => updateTask()} hidden={viewMode}>
          Update Task
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={`${viewMode ? "View" : "Edit"} Task`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={actionUI()}
          />
        </Card>
      </Affix>

      {processId.length > 0 && <NewTaskForm form={form} isEdit={true} viewMode={viewMode} processId={processId} />}
    </>
  );
};

export default UpdateNewTask;
